import { render, staticRenderFns } from "./MarchandPage.vue?vue&type=template&id=e949e1cc&"
import script from "./MarchandPage.vue?vue&type=script&lang=js&"
export * from "./MarchandPage.vue?vue&type=script&lang=js&"
import style0 from "./MarchandPage.vue?vue&type=style&index=0&id=e949e1cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports